module.exports = __webpack_public_path__ + "img/savings-cloud-m.91fc6b55.png";